export default "__VITE_ASSET__Cum5AJqx__"